export const loginApiRoutes = {
  LOGIN: 'v1/authentication/login',
  USER_STATE: 'v1/authentication/state',
  REFRESH_TOKEN: 'v1/authentication/refresh-token',
  PASSWORD_FORCE: 'v1/authentication/password/force',
};
